import { FC } from "react";

import styles from "./Pager.module.css";

interface Props {
  page: number;
  pages: number;
  disabled?: boolean;
  onChange: (page: number) => void;
}

// Пагинация «назад / N из M / вперёд»; при одной странице не показывается.
export const Pager: FC<Props> = ({ page, pages, disabled, onChange }) => {
  if (pages <= 1) return null;

  return (
    <div className={styles.pager}>
      <button
        type="button"
        className={styles.button}
        disabled={disabled || page <= 1}
        onClick={() => onChange(page - 1)}
      >
        ‹
      </button>
      <span className={styles.label}>
        {page} / {pages}
      </span>
      <button
        type="button"
        className={styles.button}
        disabled={disabled || page >= pages}
        onClick={() => onChange(page + 1)}
      >
        ›
      </button>
    </div>
  );
};
